var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.41 5.33398C53.4005 5.37141 56.4153 8.34722 58.2814 11.8128C60.2178 15.4091 61.3338 20.1942 61.3338 25.3336C61.3338 30.4731 60.2178 35.2582 58.2814 38.8544C56.4114 42.3273 53.3879 45.3084 49.3848 45.3335C42.9847 45.4493 35.867 42.9287 29.5817 41.7859L30.3129 51.291C30.5793 54.749 29.5999 58.2721 25.4912 58.6178C22.6409 58.8576 19.6276 58.8507 16.7859 58.6256C13.3919 58.3567 11.9535 55.4418 11.7301 52.3086L10.7294 38.2993C9.95445 38.1042 9.2652 37.8757 8.6309 37.5641C5.91853 36.2318 3.89858 33.8115 3.07293 30.9045C2.18116 27.7648 2.17647 22.9186 3.07293 19.7624C3.89858 16.8554 5.91853 14.4351 8.6309 13.1027C9.97168 12.4441 11.5581 12.1566 13.6804 11.772C25.4167 9.63818 45.3337 5.33373 49.41 5.33398ZM49.5281 39.9917L48.2693 39.7629C47.2957 39.3437 46.1567 38.3216 45.0821 36.3259C43.6405 33.6487 42.6671 29.7671 42.6671 25.3336C42.6671 20.9001 43.6405 17.0186 45.0821 14.3414C45.9718 12.689 46.9056 11.7041 47.7533 11.1762C48.0837 10.9704 48.4642 10.8686 48.8472 10.799C49.2982 10.717 49.7668 10.6724 50.1987 10.8259C51.2141 11.1869 52.4366 12.2076 53.5855 14.3414C55.0271 17.0186 56.0005 20.9001 56.0005 25.3336C56.0005 29.7671 55.0271 33.6487 53.5855 36.3259C52.1697 38.9553 50.6421 39.8946 49.5281 39.9917Z",
    fill: "#72C420"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesContact);
export default __webpack_public_path__ + "static/media/sales-contact.561f30f0578cc08629da52fe864c299a.svg";
export { ForwardRef as ReactComponent };